import { render } from "./App.vue?vue&type=template&id=66e3dab0"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "@/styles/global.scss?vue&type=style&index=0&lang=scss"
import "@/static/fontello/css/fontello.css?vue&type=style&index=1&lang=css"
script.render = render

export default script